import React, { FC, memo } from 'react';

type Props = {
  className?: string;
}

export const Loader: FC<Props> = memo(function Loader({ className = '' }) {
  return <div className={`LoaderComponent ${className}`}></div>;
});
